$(document).ready(function () {
    initReportForm();
});

function initReportForm() {
    let form = $('.report-form');
    if (form.length === 0) {
        return null;
    }

    $('select.select2').select2({
        placeholder: '---',
        allowClear: true
    });


    form
        .on('submit', function () {
            $('input', this).each(function () {
                if ($(this).val().length === 0) {
                    $(this).attr('disabled', 'disabled');
                }
            });
            return true;
        })
    ;

    let autosubmit_form = $('.report-form.autosubmit');
    autosubmit_form
        .on('dp.change', 'input[name="start"], input[name="end"]', function () {
            if ($(this).data('init') === undefined) {
                $(this).attr('data-init', '1');
                return;
            }
            $(this).closest('form').submit();
        })
        .on('change', 'select, input', function () {
            $(this).closest('form').submit();
        })
    ;
}